// extracted by mini-css-extract-plugin
export default {"hulam_company_list_wrap":"HulamCompanyList_hulam_company_list_wrap__bDQvq"};